const normalizeUrl = (url: string) => (url.endsWith('/') ? url.slice(0, -1) : url);

const isAssetsHost = (url: string) => url.includes('assets.40seas.com') || url.includes('static.40seas.com');

export const getPublicUrl = () => {
    if (typeof window === 'undefined') {
        return '';
    }

    const publicUrl = window.__SETUP__?.urls?.PUBLIC_URL ?? '';
    if (publicUrl === 'undefined') {
        return '';
    }

    const isLocalhost = window.location.hostname === 'localhost';
    if (!publicUrl) {
        return isLocalhost ? window.location.origin : '';
    }

    if (isLocalhost && isAssetsHost(publicUrl)) {
        return window.location.origin;
    }

    return normalizeUrl(publicUrl);
};

export const resolveAssetUrl = (assetPath: string) => {
    if (assetPath.startsWith('http://') || assetPath.startsWith('https://')) {
        return assetPath;
    }

    const publicUrl = getPublicUrl();
    const normalizedPath = assetPath.startsWith('/') ? assetPath : `/${assetPath}`;

    return publicUrl ? `${publicUrl}${normalizedPath}` : normalizedPath;
};
